<div class="edit-job-assigned-user-wrapper">
    <ng-container *ngIf="job.assignees && job.assignees.length === 0; else assignedUser">
        <h4 class="job-detail-title">{{ 'Survey.SurveyJobPanel.Filter.AssignedTo' | translate }}</h4>
        <div class="edit-job-assigned-user-content">
            <user-filter
                class="tag-input-alternative"
                [placeholder]="'TC.Common.SearchEllipsis' | translate"
                [allUsers]="currentProjectUsers"
                (selectedUsersChange)="onUserChange($event)"
            ></user-filter>
        </div>
    </ng-container>
    <ng-template #assignedUser>
        <job-assigned-user [job]="job" canEdit="true" (delete)="onUserDelete($event)"></job-assigned-user>
    </ng-template>
</div>
